module.exports = __webpack_public_path__ + "static/media/callAccept.940aa8a5.svg";